export default __webpack_public_path__ + "static/media/collab.2caf21c2.svg";